import React from 'react';
import Navbar from '../../components/Navbar2';
import Header from '../../components/Header';
import About from '../../components/OurStory';
import Contact from '../../components/Contact';
import Services from '../../components/TheClub';
import Digital from '../../components/Digital';
import Plans from '../../components/Experience';
import AllPlans from '../../components/Invest';
import LifestyleSection from '../../components/LifestyleSection';
import './index.css';

const HomePage = () => {
  return (
    <div className="container-color page-content">
      <Navbar />
      <Header />
      <About />
      
      <div className="home-sections">
        <Services />
        <AllPlans />
        <Plans />
        <Digital />
        <LifestyleSection />
      </div>
      
      <Contact />
    </div>
  );
};

export default HomePage;
